export const AVAILABLE_TECHNICIANS: string[] = [
  'a.kwiecien@juconn.com',
  'a.mijal@juconn.com',
  'a.pankow@juconn.com',
  'a.schulz@juconn.com',
  'd.vasbender@juconn.com',
  'g.kozik@juconn.com',
  'h.hintzmann@juconn.com',
  'm.buechau@juconn.com',
  'm.maziarz@juconn.com',
  'o.welling@juconn.com',
  'k.altir@juconn.com',
  'd.baczkowski@juconn.com',
  'k.nowosielski@juconn.com',
  's.evers@juconn.com',
  'j.rommelsheim@juconn.com',
  'k.pittelkow@juconn.com',
  's.toppka@juconn.com',
  'c.wolter@juconn.com',
  'c.kaiser@juconn.com',
  'oe.ozsoy@juconn.com',
  'd.wisniewski@juconn.com',
  'n.dudek@juconn.com',
  'm.kraus@juconn.com'
];

